/* 📦 LIBS */
import { useTour } from "@reactour/tour";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button } from "../../../../Components";

/* 📁 ASSETS*/
import { Back } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, MonthContainer, ContainerMonths, BackIcon,
    // TypeSelect, TypeOption 
} from "./styles";

/* 🔧 UTILS */
import { GetCardsColor } from "../../../../util/Colors";
import { getMonthInitiais, getDataString } from "../../../../util/Months";

const Months = ({id, ChangeMonths, Changeyear, disabled, ChangeMode, currentmonth, year, mode, CardStatus, showDayButton, BackToday}) => {
    
    const { isOpen } = useTour();

    const months = [];
    for(let i=0; i< 12; i++){
        months.push(i)
    }
    const DataObject = new Date();
    const LastMonth = DataObject.getMonth();
    const currentyear = DataObject.getFullYear();
    const yearOptions = [];
    const { t } = useTranslation(); 
    
    for (let i=2023; i<=currentyear; i++){
        yearOptions.push(i)
    }

    let color = GetCardsColor(CardStatus)

    return (
        <Container>
            {/* <TypeSelect $border={color.border} $color={color.background} disabled={disabled}  value={mode} onChange={(e)=>{ChangeMode(e.target.value)}}>
                <TypeOption value={0}> MÊS </TypeOption>
                <TypeOption value={1}> SEMANA </TypeOption>
                <TypeOption value={1}> DIA </TypeOption>
            </TypeSelect> */}

            {/* <SelectMonth value={currentmonth} onChange={(e)=>ChangeMonths(getDataString(parseInt(e.target.value)+1))}>
                {months.map((month, index)=>(
                    <StyledOption key={index} value={index} disabled={(parseInt(year) === currentyear && index > LastMonth) || disabled}> {getMonthString(index)} </StyledOption>
                ))}
            </SelectMonth> */}

            <ContainerMonths>
                {months.map((month, index) => (
                    <MonthContainer $background={color.background} disabled={(parseInt(year) === currentyear && index > LastMonth) || disabled} key={index} $selected={index === currentmonth} onClick={()=>ChangeMonths(getDataString(index+1))}>
                        {getMonthInitiais(month)}
                    </MonthContainer>
                ))}
            </ContainerMonths>
    
            {(showDayButton || isOpen) &&
                <Button text={t("buttons.today")} id={id} color={'green'} icon={<BackIcon src={Back} />} onClick={() => BackToday()}/>
            } 

            {/* <TypeSelect $border={color.border} $color={color.background} disabled={disabled} value={year} onChange={(e)=> {Changeyear(e.target.value)}}>
                {yearOptions.map((option, index)=>(
                    <TypeOption value={option} key={index}> {option} </TypeOption>
                ))}
            </TypeSelect> */}
        </Container>
    );
}

export default Months;
